import React, { useEffect, useState } from "react";
import { Box, Card, CardContent, CardMedia, Typography, List, ListItem, ListItemText, Grid, Paper, Tabs, Tab } from "@mui/material";
import { useLocation } from "react-router-dom";
import ReusableHeadingComponents from "../../components/reusableComponents/reusableHeadingComponents";
import { useHistory } from "react-router-dom";
import ApiService from "../../_services/ApiService";
import ReusableCardView from "../../components/reusableComponents/ReusableCardView";
import NoResults from "../../components/reusableComponents/NoResults";
import SingleDataCard from "../../components/reusableComponents/SingleDataCard";
import D3LineChart from "../../components/reusableComponents/D3LineChart";
import { CardSkeletonCollab, CardSkeletonCount } from "../../components/reusableComponents/SkeletonCard";
import ReusableTabs from "../../components/reusableComponents/reusableTabs";
import { formatCardData, getCurrentMonthAndWeek, transformData } from "../../components/reusableComponents/formatCardData";
import TablecomponentAnalytics from "../../components/reusableComponents/TablecomponentAnalytics";
import DynamicToggleTabs from "../../components/reusableComponents/DynamicToggleTabs";

const ViewOfferManagement = () => {
    const history = useHistory();
    const location = useLocation()?.state;
    const locationEventDetail = location?.eventData
    const [loader, setLoader] = useState(false);
    const [offerViewList, setOfferViewList] = useState(locationEventDetail);
    const [chartData, setChartData] = useState([]);
    const [chartDataApply, setChartDataApply] = useState([]);
    const [chartDataCreator, setChartDataCreator] = useState([]);
    const [chartDataApplyCreator, setChartDataApplyCreator] = useState([]);
    const [value, setValue] = React.useState(0);
    const [formattedData, setFormattedData] = useState();
    const { month, week } = getCurrentMonthAndWeek();
    const [chartFullData, setChartFullData] = useState([]);
    const [chartFullDataApply, setChartFullDataApply] = useState([]);
    const [chartFullDataCreator, setChartFullDataCreator] = useState([]);
    const [chartFullDataApplyCreator, setChartFullDataApplyCreator] = useState([]);
    const [revnueValue, setRevnueValue] = useState('Youth');

    const backClickHistory = () => {
        history.push('/offer-management')
    }
    useEffect(() => {
        setLoader(true);

        Promise.all([
            ApiService.get(
                'offerApplicantClick',
                { month, week },
                `click_analytics/offer/${locationEventDetail?.id}/students/`
            ),
            ApiService.get(
                'offerApplicantClick',
                { month, week },
                `apply_analytics/offer/${locationEventDetail?.id}/students/`
            ),
            ApiService.get(
                'offerApplicantClick',
                { month, week },
                `click_analytics/offer/${locationEventDetail?.id}/creators/`
            ),
            ApiService.get(
                'offerApplicantClick',
                { month, week },
                `apply_analytics/offer/${locationEventDetail?.id}/creators/`
            )
        ])
            .then(([offerRes, applyRes, offerCreatRes, applyCreatRes]) => {
                if (
                    (offerRes?.status === 200 || offerRes?.status === 201) &&
                    (applyRes?.status === 200 || applyRes?.status === 201) &&
                    (offerCreatRes?.status === 200 || offerCreatRes?.status === 201) &&
                    (applyCreatRes?.status === 200 || applyCreatRes?.status === 201)
                ) {
                    const formattedCardData = formatCardData([
                        { label: 'Youth Clicks', count: offerRes?.data?.data?.total_clicks },
                        { label: 'Number of Youth', count: applyRes?.data?.data?.total_applied },
                        { label: 'Creator Clicks', count: offerCreatRes?.data?.data?.total_clicks },
                        { label: 'Number of Creator', count: applyCreatRes?.data?.data?.total_applied },
                    ]);
                    setChartFullData(offerRes?.data?.data)
                    setChartFullDataApply(applyRes?.data?.data)
                    setFormattedData(formattedCardData);
                    const transformed = transformData(offerRes?.data?.data?.week_wise);
                    setChartData(transformed);
                    const transformedApply = transformData(applyRes?.data?.data?.week_wise);
                    setChartDataApply(transformedApply);

                    setChartFullDataCreator(offerCreatRes?.data?.data);
                    setChartFullDataApplyCreator(applyCreatRes?.data?.data);
                    const transformedCreator = transformData(offerCreatRes?.data?.data?.week_wise);
                    setChartDataCreator(transformedCreator);
                    const transformedApplyCreator = transformData(applyCreatRes?.data?.data?.week_wise);
                    setChartDataApplyCreator(transformedApplyCreator);

                }
            })
            .catch(error => {
                console.error("Error fetching data:", error);
            })
            .finally(() => setLoader(false));
    }, [month, week, locationEventDetail?.id]);

    // --------- switch tab for analytics
    const handleTabSelect = (newValue) => {
        const tabValue = newValue === 1 ? 'Creators' : 'Youth';
        setRevnueValue(tabValue);
        // setRevnueValue(newValue)
    };

    return (
        <Box p={4}>
            <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'} >
                <ReusableHeadingComponents bacHistory={true} clickHandlerBack={backClickHistory} heading={`${offerViewList?.Title} Offer Details`} />
                <Box>
                    {/* <ReusableButton children={'Close offer'} variant="contained"
                        classNames={'gn-actionbtn'} /> */}
                    {/* <ReusableButton children={'Edit'} variant="contained"
                        classNames={'gn-actionbtn'} /> */}
                </Box>
            </Box>
            {/* --------------- cards ------------ */}
            <Box sx={{ display: 'flex', gap: '20px' }}>
                {loader ? (
                    ['', '', '', ''].map((d, i) => (
                        <Grid item xs={12} sm={12} md={12} lg={12} key={i}>
                            <CardSkeletonCount />
                        </Grid>
                    ))
                ) : (formattedData && formattedData.map((item, index) => (
                    <SingleDataCard
                        key={index}
                        cardHeading={item.label}
                        count={item.value}
                        bg={item.bgcolor}
                        cardbg={item.cardbg}
                    />)
                ))}
            </Box>

            {/* 0---------------- tab switch analytics and offer details ------------- */}

            <Box sx={{ width: '100%', mt: 3 }}>
                <ReusableTabs setValue={setValue} value={value} />
            </Box>

            {value == 0 ? <Grid container spacing={2} mt={3}>
                <Grid item xs={12} sm={12} md={6} lg={6} >
                    {/* -------- overview ---------------- */}
                    <ReusableCardView title="Overview" Component={
                        <Box p={3}>
                            <Box sx={{ height: 185, width: 385 }}>
                                <img src={offerViewList?.Featured_Banner || offerViewList?.Featured_Banner_URL} className="w-100 h-100 object-fit-contain" />
                            </Box>
                            <Typography variant="h6" sx={{ fontWeight: "bold", fontSize: '18px' }}>
                                {offerViewList?.Title}
                            </Typography>
                            {offerViewList?.SubTitle && <Typography variant="span" sx={{ display: 'block', my: 1, color: '#7A7A7A' }}>{offerViewList?.SubTitle}</Typography>}
                            {/* About the Offer */}
                            <Typography variant="body1" sx={{ fontWeight: "bold", display: "inline", fontSize: '16px', }}>
                                About the Offer -
                                <Typography variant="span" sx={{ fontWeight: 'normal', color: "#7A7A7A" }} dangerouslySetInnerHTML={{ __html: offerViewList?.Abouttheoffer }}
                                />
                            </Typography>

                            {/* Valid Till */}
                            <Typography variant="body2" sx={{ fontWeight: "bold", marginTop: 1, fontSize: '16px', }}>
                                Valid till :
                                <Typography component="span" sx={{ fontWeight: "normal", color: "#7A7A7A" }}>
                                    {" "}{offerViewList?.ValidTillDate}
                                </Typography>
                            </Typography>

                        </Box>
                    } />
                </Grid>
                {/* --------- term & condition */}
                <Grid item xs={12} sm={12} md={6} lg={6} >

                    <ReusableCardView title="Terms & Conditions " Component={
                        offerViewList?.Termsconditions ? <Box p={3}>
                            <Typography variant="span" sx={{ fontWeight: 'normal', color: "#7A7A7A" }} dangerouslySetInnerHTML={{ __html: offerViewList?.Termsconditions }}
                            />
                        </Box>
                            : loader ? (
                                [''].map((d, i) => (
                                    <Grid item xs={12} sm={12} md={12} lg={12} key={i}>
                                        <CardSkeletonCollab />
                                    </Grid>
                                ))
                            )
                                :
                                <NoResults eventNoData={'No Terms & Conditions '} />
                    }
                    />
                </Grid>

                {offerViewList?.FAQ && <Grid item xs={12} sm={12} md={6} lg={6} >

                    <ReusableCardView title="FAQ" Component={
                        <Box p={3}>
                            <Typography variant="span" sx={{ fontWeight: 'normal', color: "#7A7A7A" }} dangerouslySetInnerHTML={{ __html: offerViewList?.FAQ }}
                            />
                        </Box>
                    }
                    />
                </Grid>}
                {/* --------------- how to redeem ----------- */}
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    {offerViewList?.Howtoredeem ?
                        <ReusableCardView title="How To Redeem" Component={
                            <Box p={3}>
                                <Typography variant="span" sx={{ fontWeight: 'normal', color: "#7A7A7A" }} dangerouslySetInnerHTML={{ __html: offerViewList?.Howtoredeem }}
                                />
                            </Box>
                        } /> : loader ? (
                            [''].map((d, i) => (
                                <Grid item xs={12} sm={12} md={12} lg={12} key={i}>
                                    <CardSkeletonCollab />
                                </Grid>
                            ))
                        )
                            : null}
                </Grid>
            </Grid>
                :
                <Box>
                    <Box className='d-flex justify-content-end align-items-center flex-wrap'>
                        <DynamicToggleTabs value1="Youth" value2="Creators" onSelectTab={handleTabSelect} revnueValue={revnueValue} />
                    </Box>
                    <Grid container spacing={2}>


                        <Grid item xs={12} sm={12} md={6} lg={6} >
                            {/* -------- User Insight  ---------------- */}
                            <ReusableCardView title="User Insight " Component={
                                 (revnueValue === 'Youth' ? chartData : chartDataCreator).length ? <Box >
                                    <D3LineChart
                                        data={revnueValue === 'Youth' ? chartData : chartDataCreator}
                                        xKey={(revnueValue === 'Youth' ? chartData : chartDataCreator)[0]?.day ? "day" : "month"}
                                        yKey="value"
                                        title={`${revnueValue === 'Youth' ? 'Youth' : 'Creator'} Clicks`}
                                        color="#4F46E5"
                                        width={500}
                                        height={250}

                                    // timeFrames={["This week", "This month"]}
                                    // onTimeFrameChange={handleTimeFrameChange}
                                    // timeFrames={timeFrames}
                                    // onTimeFrameChange={(timeFrame) => {
                                    //     setSelectedTimeFrame(timeFrame);
                                    //     // fetchData(selectedMonth, timeFrame === "This Week" ? currentWeek : parseInt(timeFrame.split(" ")[1]));
                                    // }}
                                    />
                                </Box>
                                    :
                                    loader ? (
                                        [''].map((d, i) => (
                                            <Grid item xs={12} sm={12} md={12} lg={12} key={i}>
                                                <CardSkeletonCollab />
                                            </Grid>
                                        ))
                                    ) : null
                            } />

                            
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={6} >
                            {/* -------- Application Over Time     ---------------- */}
                            <ReusableCardView title="Application Over Time " Component={
                                (revnueValue === 'Youth' ? chartDataApply : chartDataApplyCreator).length ? <Box >
                                    <D3LineChart
                                        data={revnueValue === 'Youth' ? chartDataApply : chartDataApplyCreator}
                                        xKey={(revnueValue === 'Youth' ? chartDataApply : chartDataApplyCreator)[0]?.day ? "day" : "month"}
                                        yKey="value"
                                        title={`${revnueValue === 'Youth' ? 'Youth' : 'Creator'} Applied Applicants`}
                                        color="#4F46E5"
                                        width={500}
                                        height={250}
                                    // timeFrames={["This week", "This month"]}
                                    // onTimeFrameChange={handleTimeFrameChange}
                                    // timeFrames={timeFrames}
                                    // onTimeFrameChange={(timeFrame) => {
                                    //     setSelectedTimeFrame(timeFrame);
                                    //     // fetchData(selectedMonth, timeFrame === "This Week" ? currentWeek : parseInt(timeFrame.split(" ")[1]));
                                    // }}
                                    />
                                </Box> :
                                    loader ? (
                                        [''].map((d, i) => (
                                            <Grid item xs={12} sm={12} md={12} lg={12} key={i}>
                                                <CardSkeletonCollab />
                                            </Grid>
                                        ))
                                    ) : null
                            } />

                            
                        </Grid>
                        {/* -------------------- Applicants table data -------------- */}
                        <Grid item xs={12} sm={12} md={12} lg={12} >
                            {/* <OfferTableView /> */}
                            {/* <ReusableCardView title="Offer Clicks" Component={<TablecomponentAnalytics loader={loader} chartData={revnueValue === 'Youth' ? chartFullData : chartFullDataCreator} title="Clicks" />} /> */}

                            <ReusableCardView title="Offer Applied" Component={<TablecomponentAnalytics loader={loader} chartData={revnueValue === 'Youth' ? chartFullDataApply : chartFullDataApplyCreator} title="Applied" />} />
                        </Grid>
                    </Grid>
                </Box>
            }
        </Box>
    );
};

export default ViewOfferManagement;
